import React, { useState } from "react";
import useTranslationEncapsulated from "../../Libs/useTranslation";
import "./index.scss";
import GlowCard from "./GlowCard";

export default function GlowCards({
  data,
  options = {
    theme: "light",
    description: "right",
    title: "left",
  },
}) {
  const items = [
    {
      title: "Remove the complexity of website translation",
      label: "No Code",
      linkText:"See Integrations"
    },
    {
      title: "Put your website translation project on autopilot",
      label: "Autopilot Mode",
      linkText:"Discover"
    },
    {
      title: "Translation quality without months of manual work",
      label: "Quality of Content",
      linkText:"Discover"
    },
    {
      title: "Reach new audiences with multilingual SEO",
      label: "Expand New Markets",
      linkText:"How It Works"
    },
  ];
  const { getTranslatableContent, Trans, getRawKey, t } =
    useTranslationEncapsulated();
  return (
    <section
      className={`glow-cards__section js-section_nav-dark`}
    >
      <div className="container mx-auto">
        <div className="glow-cards__container">
          <div className="glow-cards__main">
            <div className="glow-cards__main-title" dangerouslySetInnerHTML={{
              __html: getTranslatableContent(data?.title),
            }}/>
            <div className="glow-cards__main-desc">{data.description}</div>
          </div>
          <div className="glow-cards__wrapper">
            <GlowCard items={items} />
          </div>
        </div>
      </div>
    </section>
  );
}
